<div
  id="flycut-share"
  *ngIf="!fromFlyPlates"
  style="display: flex; justify-content: flex-start"
>
  <div style="display: flex; flex-direction: column; flex: 1 1 100%; max-width: 57%">
    <p class="share">Share {{ flycutIds.length }} FlyMSG</p>
    <span style="font-weight: 600; font-size: 16px"> Copy Link</span>
    <!-- Shared app-copy-link-field owns the clipboard copy + "Link copied!"
         tooltip; the one-time clone POST stays here via (copied). -->
    <app-copy-link-field [value]="flyshareInviteLink" (copied)="onLinkCopied()"></app-copy-link-field>
    <div class="separator" style="margin-right: 22px">
      &nbsp;&nbsp; or &nbsp;&nbsp;
    </div>
    <span class="form-span">Send from:</span>
    <span style="color: #4f4f4f; font-weight: 300; font-size: 14px"
      >We recommend using a name that the recipient will recognize</span
    >
    <form [formGroup]="form" (ngSubmit)="share()">
      <!-- M1: was a `<table cellspacing="0">` whose `<td>`s had no padding —
           Material's form-field padding used to fake the gutter, vng-input has
           none, so the two inputs butted together. -->
      <div class="name-row">
        <vng-input
          label="First Name"
          placeholder="First Name"
          class="name-row__field"
          [formControl]="form.controls['first_name']"
          [error]="
            (form.controls['first_name'].dirty || form.controls['first_name'].touched) ? (
              form.controls['first_name'].hasError('required') ? 'First name is required.' :
              form.controls['first_name'].hasError('pattern') ? 'Numbers not allowed.' :
              form.controls['first_name'].hasError('maxlength') ? ('Max length is ' + nameMaxLength + '.') : ''
            ) : ''
          "
        ></vng-input>
        <vng-input
          label="Last Name"
          placeholder="Last Name"
          class="name-row__field"
          [formControl]="form.controls['last_name']"
          [error]="
            (form.controls['last_name'].dirty || form.controls['last_name'].touched) ? (
              form.controls['last_name'].hasError('required') ? 'Last name is required.' :
              form.controls['last_name'].hasError('pattern') ? 'Numbers not allowed.' :
              form.controls['last_name'].hasError('maxlength') ? ('Max length is ' + nameMaxLength + '.') : ''
            ) : ''
          "
        ></vng-input>
      </div>
      <span class="form-span"
        >Send Email to<span style="color: #ff0000">*</span>:
      </span>

      <vng-form-field
        label="Emails"
        class="example-chip-list"
        [error]="invalidEmail() ? 'Please enter a valid email address' : ''"
      >
        <div class="chip-list-wrapper">
          <vng-chip *ngFor="let email of emails" [removable]="true" (removed)="remove(email)">{{ email }}</vng-chip>
          <input
            #emailInput
            type="text"
            class="chip-input"
            aria-label="Emails"
            placeholder="Email (Separate with comma)"
            (keydown.enter)="addFromInput(); $event.preventDefault()"
            (keydown.comma)="addFromInput(); $event.preventDefault()"
            (keyup)="onKeyUp($event)"
            (blur)="addFromInput()"
            (paste)="onPaste($event)"
          />
        </div>
      </vng-form-field>

      <span class="form-span"
        >Personalized Message
        <span style="color: #757575; font-weight: 400; margin-bottom: 8px">
          (Optional)</span
        ></span
      >
      <vng-textarea
        placeholder="Personalized Message"
        [resize]="'none'"
        [formControl]="form.controls['message']"
        class="message-textarea"
      ></vng-textarea>
    </form>

    <div style="display: flex; justify-content: flex-start; align-items: flex-end">
      <button
        onclick="this.blur()"
        style="margin-top: 12px; width: 150px"
        (click)="share()"
        vng-button
        variant="primary"
        [disabled]="
          !emails ||
          emails.length < 1 ||
          form.controls['first_name'].hasError('required') ||
          form.controls['last_name'].hasError('required') ||
          form.controls['last_name'].hasError('pattern') ||
          form.controls['first_name'].hasError('pattern') ||
          form.controls['first_name'].hasError('maxlength') ||
          form.controls['last_name'].hasError('maxlength') ||
          invalidEmail()
        "
      >
        Share
      </button>
      <span
        style="font-weight: 600; font-size: 18px; margin-left: 10px"
        *ngIf="showFlyMsgShared"
        >FlyMSG Shared!</span
      >
    </div>
  </div>

  <div style="display: flex; flex-direction: column; flex: 1 1 100%; max-width: 43%; background-color: #f5f5f5">
    <!-- M1: the gray column bleeds into the dialog panel's own 1rem padding so
         it reaches the panel edge on three sides. It used to be a fixed 375px
         box with `margin: -24px 0` (Material's old 24px padding, vertical
         only), which overflowed the 43% column and pushed the close button past
         the panel's right edge, where `overflow: auto` clipped it. -->
    <div
      style="
        background-color: #f5f5f5;
        height: -webkit-fill-available;
        margin: -1rem -1rem -1rem 0;
      "
    >
      <div
        style="
          display: flex;
          justify-content: flex-end;
          padding: 8px 12px 0 0;
          background-color: #f5f5f5;
        "
      >
        <app-dialog-close-button
          class="close-button"
          [size]="30"
          [compact]="true"
          color="black"
          (closed)="close()"
        ></app-dialog-close-button>
      </div>
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          background-color: #f5f5f5;
          padding-left: 10px;
          width: 100%;
          margin-top: 8rem;
        "
      >
        <div style="text-align: center">
          <img
            width="150"
            height="120"
            src="../../../../assets/images/handshake.gif"
            alt="Handshake Gif"
          />
          <p>{{ inviteCounter }} people signed up</p>
        </div>

        <div
          class="radio-group"
          style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            flex: 1 1 100%;
            max-height: 60%;
          "
        >
          <!-- Each milestone is its own single-item vng-radio-group: vng-radio-button's
               `checked` is only ever driven by a wrapping group's CVA value (no standalone
               [checked] input, unlike mat-radio-button which the original relied on via
               `checked="{{}}"` attribute interpolation) — see cheatsheet #23/new gotcha. -->
          <vng-radio-group [ngModel]="!!firstPersonSignedUp" class="radio-button-group">
            <vng-radio-button
              class="radio-button"
              [value]="true"
              [disabled]="!firstPersonSignedUp"
              style="text-align: start !important"
            >
              <span>Get Unlimited FlyCuts</span>
              <span style="display: block; text-align: start; font-weight: normal"
                >1st person to sign up</span
              >
              <hr
                [ngClass]="
                  !!firstPersonSignedUp
                    ? 'radio-completed'
                    : 'radio-not-completed'
                "
                style="height: 32px; margin-top: -11px; margin-bottom: -21px"
              />
            </vng-radio-button>
          </vng-radio-group>
          <vng-radio-group [ngModel]="!!secondPersonSignedUp" class="radio-button-group">
            <vng-radio-button
              class="radio-button"
              [value]="true"
              [disabled]="!secondPersonSignedUp"
              style="text-align: start !important"
            >
              <span>Get Unlimited Characters</span>
              <span style="display: block; text-align: start; font-weight: normal"
                >2nd person to sign up</span
              >
              <hr
                [ngClass]="
                  !!secondPersonSignedUp
                    ? 'radio-completed'
                    : 'radio-not-completed'
                "
                style="height: 44px; margin-top: -11px; margin-bottom: -33px"
              />
            </vng-radio-button>
          </vng-radio-group>
          <vng-radio-group [ngModel]="!!thirdPersonSignedUp" class="radio-button-group">
            <vng-radio-button
              class="radio-button"
              [value]="true"
              [disabled]="!thirdPersonSignedUp"
              style="text-align: start !important"
            >
              <span
                >Get Access to One Additional <br />
                FlyCuts Category</span
              >
              <span style="display: block; text-align: start; font-weight: normal"
                >3rd person to sign up</span
              >
              <hr
                [ngClass]="
                  !!thirdPersonSignedUp
                    ? 'radio-completed'
                    : 'radio-not-completed'
                "
                style="height: 42px; margin-top: -21px; margin-bottom: -21px"
              />
            </vng-radio-button>
          </vng-radio-group>
          <vng-radio-group [ngModel]="!!fourthPersonSignedUp" class="radio-button-group">
            <vng-radio-button
              class="radio-button"
              [value]="true"
              [disabled]="!fourthPersonSignedUp"
              style="text-align: start !important"
            >
              <span>Get Access to All FlyPlates</span>
              <span style="display: block; text-align: start; font-weight: normal"
                >4th person to sign up</span
              >
            </vng-radio-button>
          </vng-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="fromFlyPlates">
  <!-- R8: raw close markup -> the shared app-dialog-close-button (share flavor:
       30px, black), same as the header close at :141. -->
  <app-dialog-close-button
    class="close-button-icon"
    [size]="30"
    color="black"
    (closed)="close()"
  ></app-dialog-close-button>

  <div style="text-align: center">
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31 5.8125C26.0184 5.8125 21.1486 7.28972 17.0066 10.0574C12.8645 12.825 9.63618 16.7587 7.7298 21.3612C5.82341 25.9636 5.32462 31.0279 6.29648 35.9138C7.26835 40.7997 9.66722 45.2877 13.1898 48.8103C16.7123 52.3328 21.2003 54.7317 26.0862 55.7035C30.9721 56.6754 36.0364 56.1766 40.6388 54.2702C45.2413 52.3638 49.175 49.1355 51.9427 44.9934C54.7103 40.8514 56.1875 35.9816 56.1875 31C56.1811 24.3218 53.5254 17.919 48.8032 13.1968C44.081 8.47465 37.6782 5.81891 31 5.8125ZM31 52.3125C26.7848 52.3125 22.6642 51.0625 19.1594 48.7207C15.6546 46.3788 12.9229 43.0503 11.3098 39.1559C9.69674 35.2616 9.27468 30.9764 10.097 26.8421C10.9194 22.7079 12.9492 18.9104 15.9298 15.9298C18.9104 12.9492 22.7079 10.9194 26.8421 10.097C30.9764 9.27467 35.2616 9.69672 39.156 11.3098C43.0503 12.9229 46.3789 15.6546 48.7207 19.1594C51.0626 22.6642 52.3125 26.7848 52.3125 31C52.3061 36.6505 50.0586 42.0677 46.0631 46.0631C42.0677 50.0586 36.6505 52.3061 31 52.3125ZM34.875 42.625C34.875 43.1389 34.6709 43.6317 34.3075 43.995C33.9442 44.3584 33.4514 44.5625 32.9375 44.5625H31C30.4862 44.5625 29.9933 44.3584 29.63 43.995C29.2666 43.6317 29.0625 43.1389 29.0625 42.625V31C28.5487 31 28.0558 30.7959 27.6925 30.4325C27.3291 30.0692 27.125 29.5764 27.125 29.0625C27.125 28.5486 27.3291 28.0558 27.6925 27.6925C28.0558 27.3291 28.5487 27.125 29.0625 27.125H31C31.5139 27.125 32.0067 27.3291 32.37 27.6925C32.7334 28.0558 32.9375 28.5486 32.9375 29.0625V40.6875C33.4514 40.6875 33.9442 40.8916 34.3075 41.255C34.6709 41.6183 34.875 42.1111 34.875 42.625ZM27.6094 20.3438C27.6094 19.7689 27.7798 19.2071 28.0992 18.7291C28.4185 18.2512 28.8724 17.8787 29.4035 17.6587C29.9345 17.4388 30.5189 17.3812 31.0826 17.4933C31.6464 17.6055 32.1642 17.8823 32.5707 18.2887C32.9771 18.6952 33.2539 19.213 33.366 19.7768C33.4782 20.3405 33.4206 20.9249 33.2007 21.4559C32.9807 21.987 32.6082 22.4409 32.1303 22.7602C31.6523 23.0796 31.0904 23.25 30.5156 23.25C29.7449 23.25 29.0056 22.9438 28.4606 22.3988C27.9156 21.8538 27.6094 21.1145 27.6094 20.3438Z"
        fill="#F15A2A"
      />
    </svg>
    <h3 style="font-size: 18px">You cannot share a FlyPlate</h3>
    <p style="color: rgba(117, 117, 117, 1)">
      {{
        multiSelect()
          ? "One or more of the selected messages were saved from FlyPlates "
          : "The selected FlyMSG was saved from a FlyPlates Category"
      }}
    </p>
    <button (click)="close()" vng-button variant="primary">Continue</button>
  </div>
</div>
